import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import LeaseService from '../Services/LeaseService';
import {extractErrorMessage} from '../Services/RequestService';
import {removeFromCollection, replaceInCollection} from './utils';

//agreementId is optional if you only need to query data
export const useLeases = (agreementId) => {
    const [leases, setLeases] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            let resp = await LeaseService.allLeases(token);
            let leases = resp.data;
            if(agreementId){
                leases = leases.filter((lease) => {
                    return lease.agreement === agreementId;
                });
            }
            setLeases(leases);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const addLease = async (lease) => {
        try {
            lease.agreementId = agreementId;
            let resp = await LeaseService.addLease(lease, token);
            setLeases([...leases, {...lease, id: resp.data.id}]);
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const updateLease = async (lease) => {
        try {
            lease.agreementId = agreementId;
            await LeaseService.updateLease(lease, token);
            setLeases(replaceInCollection(lease, leases));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const deleteLease = async (lease) => {
        try {
            await LeaseService.deleteLease(lease.id, token);
            setLeases(removeFromCollection(lease, leases));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    useEffect(() => {
        loadAll()
    }, []);

    return [leases, addLease, updateLease, deleteLease];
}


// WEBPACK FOOTER //
// ./src/Hooks/useLeases.js